import React from "react";

export default function Newsandevents() {
  return (
    <div style={styles.container}>
      {/* GLOBAL CSS INJECTION - Removes scrollbars and white margins from the page */}
      <style>{`
        html, body {
          margin: 0;
          padding: 0;
          background: #020617; /* Fills white edges with your theme color */
          overflow: hidden;    /* Removes browser scrollbar */
        }

        /* Hide scrollbars for Chrome, Safari and Opera */
        *::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbars for IE, Edge and Firefox */
        * {
          -ms-overflow-style: none;  
          scrollbar-width: none; 
          box-sizing: border-box;
        }
      `}</style>

      <div style={styles.header}>
        <h2 style={styles.title}>LIVE ECONOMIC CALENDAR</h2>
      </div>
      
      <div style={styles.widgetWrapper}>
        {/* Professional Economic Calendar Widget from Tradays */}
        <iframe 
          src="https://www.tradays.com/en/economic-calendar/widget?mode=2&utm_source=localhost" 
          width="100%" 
          height="100%" 
          frameBorder="0"
          style={{ borderRadius: '12px' }}
        ></iframe>
      </div>

      <div style={styles.footer}>
        Real-time data provided by Tradays Economic Calendar
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    width: "100%",
    background: "transparent",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  header: {
    paddingBottom: "15px",
    borderBottom: "1px solid #1e293b",
    marginBottom: "15px"
  },
  title: {
    fontSize: "14px",
    fontWeight: "900",
    color: "#f1f5f9",
    letterSpacing: "1px"
  },
  widgetWrapper: {
    flex: 1,
    background: "#0d1117",
    borderRadius: "12px",
    border: "1px solid #1e293b",
    overflow: "hidden"
  },
  footer: {
    textAlign: "center",
    fontSize: "10px",
    color: "#334155",
    padding: "15px"
  }
};